import { ResponseData } from "src/app/@types/interfaces/get.response";
import { CoreService } from "./core.service";
import timeSheetData from "src/app/data/admin-timesheet-data.json";
import { TimeSheet } from "src/app/interfaces/timesheet";

class AdminTimeSheetService extends CoreService {

    async getAll(): Promise<ResponseData<TimeSheet[]>> {
        return new Promise((resolve, reject) => {
            try {
                const response: ResponseData<TimeSheet[]> = {
                    success: true,
                    message: "TimeSheet list retrieved successfully",
                    data: timeSheetData as TimeSheet[],
                };
                resolve(response);
            } catch (error) {
                const errorMessage =
                    error instanceof Error
                        ? error.message
                        : "Failed to load TimeSheet list";
                reject(new Error(errorMessage));
            }
        });
    }


}

export const adminTimeSheetService = new AdminTimeSheetService();
